import { ENDPOINT } from '~/constants/endpoints';

import { type UUID } from '~/types/common';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import { type SupplierDetailResponse } from './types';
import { zodSupplierDetailResponseSchema } from './validations';

/**
 * Fetches the detail view for a single supplier relationship by its data exchange ID.
 *
 * Returns master data (company name, address, HRB, USt-IdNr, GLN), technical
 * integration info (interface type, activation statuses, VESTIGAS note),
 * relationship fields (supplier number, customer numbers, revenue, volumes),
 * contacts, and recent contact attempts.
 *
 * @param deId - The data exchange ID of the supplier relationship.
 * @param options - Optional ky request options (e.g., abort signal).
 * @returns The supplier detail response.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Supplier-details/operation/get_supplier_detail_suppliers_details__de_id__get
 */
export const fetchSupplierDetail = async (
  deId: UUID,
  options?: KyRequestOptions,
) =>
  vestigasApi
    .get(ENDPOINT.SUPPLIER.GET_DETAIL(deId), {
      ...options,
      validate: {
        response: zodSupplierDetailResponseSchema,
      },
    })
    .json<SupplierDetailResponse>();
